import React, { useState } from 'react';
import { Form, Input, Button, Card } from 'antd';
import { FORMDATA } from 'constants/Data';
import { postApi } from 'apis';
import { toastText } from 'utils/utils';

const ClientModeForm = (props: any) => {
  const { deviceId, setOpenClientMode } = props;
  const { clientModeFormFIelds } = FORMDATA;
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const onFinish = async(values: any) => {
    setLoading(true)
    await postApi('/devices/client-mode', {
      deviceId,
      ...values
    }).then((res: any) => {
      if (res?.data?.responseStatus === 200) {
        toastText(res?.data?.message, 'success');
      }
    }).catch((err: any) => {
      toastText(err?.response?.data?.message, 'error');
    }).finally(() => {
      setLoading(false)
      form.resetFields();
      setOpenClientMode(false);
    })
  };

  const renderFormItem = (field: any) => {
    const InputComponent = field.type === 'password' ? Input.Password : Input;
    return (
      <Form.Item
        key={field.id}
        label={field.title}
        name={field.name}
        rules={field.rules || []}
        style={{ marginTop: '5px' }}
      >
        <InputComponent placeholder={field.placeHolder} />
      </Form.Item>
    );
  };

  return (
    <Card title="Add Device">
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        autoComplete="off"
      >
        {clientModeFormFIelds.map(renderFormItem)}

        <Form.Item>
          <Button type="primary" htmlType="submit" style={{ marginTop: '20px' }} loading={loading}>
            Submit
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default ClientModeForm;
